import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=b426514a&scoped=true&"
import script from "./uploadImg.vue?vue&type=script&lang=js&"
export * from "./uploadImg.vue?vue&type=script&lang=js&"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=b426514a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b426514a",
  null
  
)

export default component.exports